import { INDEX_BY_ORDER_TAB, OrderTab } from '@src/orders/domain/OrderTab';
import { ASSIGNED_TO_ME_QUERY_KEY } from '@src/orders/hooks/useAssignedToMeState';

const ordersRootPath = '/orders';

export const OrdersNavigation = {
  PATH: ordersRootPath,
  ACTIVE_ASSIGNED_TO_ME_ORDER_PATH: `/?tabIndex=${INDEX_BY_ORDER_TAB[OrderTab.Active]}&${ASSIGNED_TO_ME_QUERY_KEY}=true`,
  create: {
    PATH: `${ordersRootPath}/create`,
    RELATIVE: 'create',
  },
  order: {
    PATH: `${ordersRootPath}/:orderId`,
    RELATIVE: ':orderId',
  },
  changeRequest: {
    PATH: `${ordersRootPath}/:orderId/changeRequest/:reason`,
    url: (orderId: string, reason: string) =>
      `${ordersRootPath}/${orderId}/changeRequest/${reason}`,
    RELATIVE: ':orderId/changeRequest/:reason',
  },
  duplicate: {
    PATH: `${ordersRootPath}/:orderId/duplicate`,
    url: (orderId: string) => `${ordersRootPath}/${orderId}/duplicate`,
    RELATIVE: ':orderId/duplicate',
  },
  orderDetail: {
    PATH: 'order=:orderId',
    url: ({
      page,
      orderId,
      tabIndex,
    }: {
      page: number;
      orderId: string;
      tabIndex: number;
    }) => `/?tabIndex=${tabIndex}&page=${page}&order=${orderId}`,
    RELATIVE: ':orderId',
  },
  edit: {
    PATH: `${ordersRootPath}/:orderId/edit`,
    url: (orderId: string, params?: Record<string, string>) =>
      `${ordersRootPath}/${orderId}/edit${params ? `?${new URLSearchParams(params).toString()}` : ''}`,
    RELATIVE: ':orderId/edit',
  },
  completePermitForm: {
    PATH: `${ordersRootPath}/:orderId/completePermitForm/:permitApplicationId`,
    url: (
      orderId: string,
      permitApplicationId: string,
      params?: Record<string, string>,
    ) =>
      `${ordersRootPath}/${orderId}/completePermitForm/${permitApplicationId}${params ? `?${new URLSearchParams(params).toString()}` : ''}`,
    RELATIVE: ':orderId/completePermitForm/:permitApplicationId',
  },
  view: {
    PATH: `${ordersRootPath}/:orderId/view`,
    url: (orderId: string, params?: Record<string, string>) =>
      `${ordersRootPath}/${orderId}/view${params ? `?${new URLSearchParams(params).toString()}` : ''}`,
    RELATIVE: ':orderId/view',
  },
  addPermits: {
    PATH: `${ordersRootPath}/:orderId/addPermits`,
    url: (orderId: string) => `${ordersRootPath}/${orderId}/addPermits`,
    RELATIVE: ':orderId/addPermits',
  },
  replacePermitType: {
    PATH: `${ordersRootPath}/:orderId/permits/:originPermitId/replacePermitType`,
    url: (orderId: string, originPermitId: string) =>
      `${ordersRootPath}/${orderId}/permits/${originPermitId}/replacePermitType`,
    RELATIVE: ':orderId/permits/:originPermitId/replacePermitType',
  },
  editCarrierAndPermitDelivery: {
    PATH: `${ordersRootPath}/:orderId/carrier-and-permit-delivery`,
    url: (orderId: string) =>
      `${ordersRootPath}/${orderId}/carrier-and-permit-delivery`,
    RELATIVE: ':orderId/carrier-and-permit-delivery',
  },
  processPermit: {
    PATH: `${ordersRootPath}/:orderId/permits/:permitId/process`,
    url: (orderId: string, permitId: string) =>
      `${ordersRootPath}/${orderId}/permits/${permitId}/process`,
    RELATIVE: ':orderId/permits/:permitId/process',
  },
  modifyStatePermit: {
    PATH: `${ordersRootPath}/:orderId/permits/:permitId/modifyStatePermit`,
    url: (orderId: string, permitId: string) =>
      `${ordersRootPath}/${orderId}/permits/${permitId}/modifyStatePermit`,
    RELATIVE: ':orderId/permits/:permitId/modifyStatePermit',
  },
  completePermit: {
    PATH: `${ordersRootPath}/:orderId/permits/:permitId/complete`,
    RELATIVE: ':orderId/permits/:permitId/complete',
    url: (orderId: string, permitId: string) =>
      `${ordersRootPath}/${orderId}/permits/${permitId}/complete`,
  },
} as const;
